"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearPreviousMessage = exports.mention = exports.complain = void 0;
var solid_ui_1 = require("solid-ui");
function complain(buttonContainer, context, error) {
    buttonContainer.appendChild(solid_ui_1.widgets.errorMessageBlock(context.dom, error));
}
exports.complain = complain;
//TODO create positive frontend message component on UI
function mention(buttonContainer, message) {
    var positiveFrontendMessageDiv = document.createElement("div");
    positiveFrontendMessageDiv.setAttribute("style", "margin: 0.1em; padding: 0.5em; border: 0.05em solid gray; background-color: #efe; color:black;");
    //positiveFrontendMessageDiv.setAttribute('style', UI.style.messageBodyStyle) -> using UI but missing green backgroung color
    positiveFrontendMessageDiv.innerHTML = message;
    buttonContainer.appendChild(positiveFrontendMessageDiv);
}
exports.mention = mention;
function clearPreviousMessage(buttonContainer) {
    while (buttonContainer.childNodes.length > 1) {
        buttonContainer.removeChild(buttonContainer.lastChild);
    }
}
exports.clearPreviousMessage = clearPreviousMessage;
//# sourceMappingURL=addMeToYourFriendsHelper.js.map